import useParams from '../../../hooks/useParamsAndCookies';
import { URLParam } from '../../../Interfaces/system/params.interfaces';
import { parseDate, parseId } from '@/src/utils/param';
import { ARFiltersArgs } from './ARFilter/ARFilters';

const params: URLParam<ARFiltersArgs>[] = [
  { label: 'reportType' },
  { label: 'period' },
  { label: 'info' },
  { label: 'customers', isEncrypted: true, multiple: true, parse: parseId },
  { label: 'contracts', isEncrypted: true, multiple: true },
  { label: 'dates', multiple: true, parse: parseDate },
];

const formatFilters = (filters: ARFiltersArgs) => {
  return {
    ...filters,
    dates: filters.dates
      ? filters.dates.map((date) => date?.toString() || null)
      : null,
  };
};

const ARParams = () => {
  useParams<ARFiltersArgs>({
    tab: 'AR',
    params,
    formatFilters,
    filterChanges: (values) => {
      const cookies = values as { dates: (string | null)[] };
      const { dates, ...otherFields } = cookies;
      const newCookies = otherFields as Record<string, unknown>;
      if (dates) {
        const start = new Date(dates[0] ?? '');
        const end = dates[1] ? new Date(dates[1]) : null;
        newCookies['dates'] = [start, end];
      }

      return newCookies;
    },
    cookieFiltersName: 'filters',
  });

  return <span />;
};

export default ARParams;
